import algoliasearch from "algoliasearch/lite";
import aa from "search-insights";

export const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_API_KEY
);

export const trackProductClickAfterSearch = (
  objectID,
  indexName,
  queryId,
  position
) => {
  if (!objectID || !queryId || !indexName || objectID == "undefined") return;

  aa("clickedObjectIDsAfterSearch", {
    eventName: "Product Clicked After Search",
    index: indexName,
    objectIDs: [objectID],
    queryID: queryId,
    positions: [position],
  });
};

export const trackAddToCartAfterSearch = (objectID, indexName, queryId) => {
  if (!objectID || !queryId || !indexName || objectID == "undefined") return;

  aa("addedToCartObjectIDsAfterSearch", {
    eventName: "Product added to cart After Search",
    index: indexName,
    objectIDs: [objectID],
    queryID: queryId,
  });
};

export const trackClickedProductOutsideSearch = (objectID, indexName) => {
  if (!objectID || !indexName || objectID == "undefined") return;
  aa("clickedObjectIDs", {
    eventName: "Product Clicked",
    index: indexName,
    objectIDs: [objectID],
  });
};

export const trackProductAddedToCartOutsideSearch = (objectID, indexName) => {
  if (!objectID || !indexName || objectID == "undefined") return;

  aa("addedToCartObjectIDs", {
    eventName: "Product added to cart",
    index: indexName,
    objectIDs: [objectID],
  });
};

export const trackViewProduct = (objectID, indexName) => {
  if (!objectID || !indexName || objectID == "undefined") return;

  aa("viewedObjectIDs", {
    eventName: "Product Viewed",
    index: indexName,
    objectIDs: [objectID],
  });
};

export const trackClickedFilters = (indexName, filters) => {
  if (!filters || !indexName) return;

  aa("clickedFilters", {
    eventName: "Filter Clicked After Search",
    index: indexName,
    filters,
  });
};

export const trackPurchasedProduct = (
  indexName,
  objectIDs,
  objectData,
  value,
  currency
) => {
  if (
    !objectIDs?.length ||
    !indexName ||
    objectData?.length !== objectIDs?.length ||
    objectIDs?.some((e) => !e || e == "undefined")
  )
    return;
  aa("purchasedObjectIDs", {
    eventName: "Product Purchased",
    index: indexName,
    objectIDs,
    objectData,
    value,
    currency,
  });
};

export const trackPurchasedProductAfterSearch = (
  indexName,
  objectIDs,
  objectData,
  value,
  currency
) => {
  if (
    !objectIDs?.length ||
    !indexName ||
    objectData?.length !== objectIDs?.length ||
    objectIDs?.some((e) => !e || e == "undefined")
  )
    return;

  aa("purchasedObjectIDsAfterSearch", {
    eventName: "Product Purchased After Search",
    index: indexName,
    objectIDs,
    objectData,
    value,
    currency,
  });
};

export const trackWishListProduct = (objectIDs, indexName, isShare) => {
  if (!objectIDs?.length || !indexName || objectIDs?.[0] === "undefined")
    return;

  aa("convertedObjectIDs", {
    eventName: `Product ${isShare ? "Shared" : "Added To Wishlist"} `,
    index: indexName,
    objectIDs,
  });
};

export const trackWishListProductAfterSearch = (
  objectIDs,
  indexName,
  queryID,
  isShare
) => {
  if (!objectIDs?.length || !indexName || objectIDs?.[0] === "undefined")
    return;

  aa("convertedObjectIDsAfterSearch", {
    eventName: `Product ${
      isShare ? "Shared" : "Added To Wishlist"
    } After Search`,
    index: indexName,
    objectIDs,
    queryID,
  });
};
